/** Shared help copy for authenticator (TOTP) setup — keep in sync with app/views/users/totp/setup.html.erb tooltips. */
export const TOTP_TOOLTIPS = {
  pageIntro:
    "Adds a second factor at sign-in: a 6-digit code from your authenticator app. Your organization must enable Authenticator app on the login page; you enroll here with your own QR code.",
  enabledStatus:
    "You can sign in with a 6-digit code when your organization has Authenticator app enabled on that login page.",
  qrCode:
    "This QR code is unique to your account. Scan it once in Google Authenticator, Authy, 1Password, or any RFC 6238 TOTP app.",
  manualKey:
    "If you cannot scan the QR code, enter this secret key manually in your authenticator app. It is the same secret encoded in the QR.",
  confirmCode:
    "Enter the current 6-digit code shown in your app. Codes change about every 30 seconds.",
  backupCodes:
    "Each backup code works once if you lose your phone. Store them in a password manager or secure note—they are shown only once.",
  regenerateCodes:
    "Issues a fresh set of backup codes. Any unused codes from the previous set stop working immediately.",
  disable:
    "Removes your authenticator secret and backup codes from this account. OTP sign-in will not work until you enroll again. Requires a current code from your app."
}
